// history.js
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({
    basename: process.env.LF_BASE_HREF
});